var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongQingchu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5V6h.5v-.5H7zm2 0h-.5V6H9v-.5zM7.5 2.25a.25.25 0 01-.25.25v-1a.75.75 0 00-.75.75h1zm0 3.25V2.25h-1V5.5h1zM2.75 6H7V5H2.75v1zM3 5.75a.25.25 0 01-.25.25V5a.75.75 0 00-.75.75h1zm0 2.5v-2.5H2v2.5h1zM2.75 8a.25.25 0 01.25.25H2c0 .414.336.75.75.75V8zm10.5 0H2.75v1h10.5V8zm-.25.25a.25.25 0 01.25-.25v1a.75.75 0 00.75-.75h-1zm0-2.5v2.5h1v-2.5h-1zm.25.25a.25.25 0 01-.25-.25h1a.75.75 0 00-.75-.75v1zM9 6h4.25V5H9v1zm-.5-3.75V5.5h1V2.25h-1zm.25.25a.25.25 0 01-.25-.25h1a.75.75 0 00-.75-.75v1zm-1.5 0h1.5v-1h-1.5v1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46 8.647a.2.2 0 01.193-.147h8.694a.2.2 0 01.193.147l1.374 5.037a.25.25 0 01-.241.316H2.327a.25.25 0 01-.24-.316L3.46 8.647z",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11v2.5M10 11v3",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_qingchu.de8754a5.svg";
export { SvgTongyongQingchu as ReactComponent };